import { useEffect, useState } from "react";
import { applyStoredConsent, getStoredConsent, grantConsent, denyConsent } from "../lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    applyStoredConsent();
    const stored = getStoredConsent();
    if (stored === null) {
      // Show after small delay so it doesn't compete with hero
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    grantConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    denyConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[90] border-t border-brand-border bg-brand-bg/95 backdrop-blur-xl shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
    >
      <div className="mx-auto flex max-w-[1600px] flex-col items-start gap-6 px-6 py-6 md:flex-row md:items-center md:justify-between md:px-12 md:py-5 lg:px-20">
        <div className="max-w-2xl text-sm leading-relaxed text-brand-ink">
          <p className="font-serif text-lg italic">Een klein verzoek</p>
          <p className="mt-1 text-brand-muted">
            We gebruiken anonieme analytics om te begrijpen welke onderdelen van deze pagina werken — zo houden we hem voor jou en toekomstige kijkers zo helder mogelijk. Geen advertenties, geen tracking buiten deze site.
          </p>
        </div>
        <div className="flex w-full shrink-0 flex-col gap-2 sm:flex-row md:w-auto">
          <button
            data-testid="cookie-decline"
            onClick={handleDecline}
            className="inline-flex items-center justify-center border border-brand-border px-6 py-3 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-surface"
          >
            Weigeren
          </button>
          <button
            data-testid="cookie-accept"
            onClick={handleAccept}
            className="inline-flex items-center justify-center bg-brand-moss px-8 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-mossDark"
          >
            Accepteren
          </button>
        </div>
      </div>
    </div>
  );
}
